<template lang="pug">
  .row
    .col-md-12
      .box.box-info.bcard-admin-dashboard-box
        .box-header.with-border
          .box-title
            a#announcement-header(role="button" href="#jbcard-collapse-announcement" @click.prevent="saveAnnouncementHeader" data-toggle="collapse")
              | 運営からのお知らせ
              |
              |
              // unread count
              .badge.bg-aqua {{countUnread || ''}}
              |
              |
              i.fa.fa-caret-down
              i.fa.fa-caret-up
        .box-body.collapse#jbcard-collapse-announcement(:class="{'in': isOpenAnnouncement}")
          loading(v-if="isLoading", :height="100")
          .admin-info(v-else-if="list.length > 0")
            .admin-info-item(v-for="(item) in list", :key="item.id", :class="{unread: item.unread === app_flag.ON}")
              .bcard-info-date {{item.formatted_date_from}}
              .bcard-info-title(:title="item.title")
                router-link.admin-info-link(:to="{name: 'announcement-detail', params: {id: item.id}}") {{item.title}}

          .panel-body.text-center(v-else) お知らせはありません。
</template>

<script>
import Loading from '@/components/molecules/Loading'
import RepositoryFactory from '@/repositories/RepositoryFactory'

const AnnouncementRepository = RepositoryFactory.get('announcement')

export default {
  name: 'IndexInfo',
  components: { Loading },
  data () {
    return {
      countUnread: null,
      isLoading: true,
      list: []
    }
  },
  computed: {
    isOpenAnnouncement () {
      // default: open
      return this.getCookie('announce_is_open') !== this.app_flag.OFF
    }
  },
  created () {
    const vm = this

    // count unread
    AnnouncementRepository.getUnreadCount()
      .then(function (response) {
        const data = vm.getApiData(response).data
        vm.countUnread = data.count
      })
      .catch(function (error) {
        vm.setErrorMessage(error)
      })

    // fetch all valid
    AnnouncementRepository.getList()
      .then(function (response) {
        const data = vm.getApiData(response).data
        vm.list = data
        vm.isLoading = false
      })
      .catch(function (error) {
        vm.setErrorMessage(error)
      })
  },
  mounted () {
    this.setCollapseAttribute(this.isOpenAnnouncement)
  },
  methods: {
    /**
     * 運営からのお知らせヘッダー開閉用の属性を追加する（最初のみ）
     */
    setCollapseAttribute (isOpen) {
      const header = document.getElementById('announcement-header')
      header.setAttribute('aria-expanded', isOpen)
    },
    /**
     * タイトルヘッダーの開閉状態をクッキーに保存する
     */
    saveAnnouncementHeader () {
      // タイトルヘッダーの開閉状態をチェック
      const isOpen = !$('#jbcard-collapse-announcement').hasClass('in')
      // クッキーに結果を保存
      this.setCookie('announce_is_open', isOpen ? this.app_flag.ON : this.app_flag.OFF)
    }
  }
}
</script>

<style lang="scss" scoped>
.admin-info {
  line-height: 20px;
}

.admin-info-item {
  display: flex;
  // 未読
  &.unread {
    font-weight: bold;
  }
}

.bcard-info-date {
  padding: 5px 15px 5px 5px;
  font-weight: bold;
  white-space: nowrap;
}

.bcard-info-title {
  padding: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/admin/IndexInfo.vue